import { render, staticRenderFns } from "./PreviewWrapper.vue?vue&type=template&id=3c3b91b4&scoped=true"
import script from "./PreviewWrapper.vue?vue&type=script&lang=js"
export * from "./PreviewWrapper.vue?vue&type=script&lang=js"
import style0 from "./PreviewWrapper.vue?vue&type=style&index=0&id=3c3b91b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3b91b4",
  null
  
)

export default component.exports